import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

// Reusable camera QR scanner. Calls onDetected(text) once per unique code (2.5s debounce).
export default function QrScanner({ active, onDetected }) {
  const idRef = useRef("qr-reader-" + Math.random().toString(36).slice(2));
  const scannerRef = useRef(null);
  const lastRef = useRef({ text: null, ts: 0 });

  useEffect(() => {
    if (!active) return;
    let cancelled = false;
    const start = async () => {
      try {
        const scanner = new Html5Qrcode(idRef.current, { verbose: false });
        scannerRef.current = scanner;
        await scanner.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 240, height: 240 } },
          (text) => {
            const now = Date.now();
            if (lastRef.current.text === text && now - lastRef.current.ts < 2500) return;
            lastRef.current = { text, ts: now };
            onDetected(text);
          },
          () => {}
        );
        if (cancelled) await scanner.stop().catch(() => {});
      } catch (e) {
        // camera unavailable / permission denied — manual entry still works
      }
    };
    start();
    return () => {
      cancelled = true;
      const s = scannerRef.current;
      if (s) {
        s.stop().then(() => s.clear()).catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [active]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div id={idRef.current} className="w-full max-w-sm mx-auto rounded-xl overflow-hidden bg-black/5" data-testid="qr-reader" />;
}
